(() => {

  const FRUIT_FINDER_TRIGGER_SELECTORS = [
  "#shopify-section-template--19976945336433__section_QEW9eL .button-custom--AUmNJZXdVTnlraXlsc__button_jqV6R6",
  "#shopify-section-template--19976945336433__product_list_diPA8c .button-custom--AOEFpSGNqOHZnNFJDN__button_XiDVU8"
].join(",");

  if (window.__fruitFinderLoaded) return;
  window.__fruitFinderLoaded = true;

  const questions = [
    {
      q: "What does your day look like?",
      hint: "Pick the one that feels most like you today.",
      options: [
        {
          id: "move",
          title: "Always on the move",
          sub: "Commutes, errands, plans, you barely stop."
        },
        {
          id: "active",
          title: "Gym, yoga or pickleball",
          sub: "Movement is part of your routine."
        },
        {
          id: "desk",
          title: "Desk-to-dinner kind of day",
          sub: "Work mode now, social mode later."
        },
        {
          id: "slow",
          title: "Taking it slow",
          sub: "A calmer day with time to reset."
        },
        {
          id: "share",
          title: "Sharing with friends & family",
          sub: "Something easy to keep in the fridge."
        }
      ]
    },
    {
      q: "What are you reaching for right now?",
      hint: "Think about the kind of refreshment your day is asking for.",
      options: [
        {
          id: "light",
          title: "Something light & refreshing",
          sub: "Clean, easy and thirst-friendly."
        },
        {
          id: "post",
          title: "A proper post-activity refresh",
          sub: "Something satisfying after moving."
        },
        {
          id: "meal",
          title: "Something fruity with my meal",
          sub: "A refreshing companion for food."
        },
        {
          id: "pick",
          title: "A little pick-me-up",
          sub: "Bright flavour to break up the day."
        },
        {
          id: "sip",
          title: "Something smooth to sip throughout the day",
          sub: "A longer, easy-drinking occasion."
        }
      ]
    },
    {
      q: "Where will your drink most likely be?",
      hint: "This helps us match the size and format to your routine.",
      options: [
        {
          id: "bag",
          title: "In my bag",
          sub: "Portable and easy to grab."
        },
        {
          id: "workout",
          title: "In my hand after a workout",
          sub: "Ready when the session ends."
        },
        {
          id: "office",
          title: "At my desk",
          sub: "A personal refresh within reach."
        },
        {
          id: "food",
          title: "With lunch or dinner",
          sub: "Made for the table."
        },
        {
          id: "fridge",
          title: "In the fridge for everyone",
          sub: "Bigger formats for home or sharing."
        }
      ]
    }
  ];

  const products = [
    {
      key: "guava-amla-245",
      name: "Guava & Amla Juice - 245ml",
      family: "MOVE",
      title: "Your Bright-On-The-Go Refresh",
      label: "GUAVA + AMLA",
      sig: ["active", "pick", "bag"],
      tags: ["active", "pick", "bag", "move", "light"]
    },
    {
      key: "orange-1l",
      name: "100% Orange Juice - 1L",
      family: "FLOW",
      title: "Your Fridge-Ready Citrus Reset",
      label: "ORANGE",
      sig: ["share", "light", "fridge"],
      tags: ["share", "light", "fridge", "sip"]
    },
    {
      key: "mango-460",
      name: "100% Mango Juice - 460ml",
      family: "RESET",
      title: "Your Tropical Midday Lift",
      label: "MANGO",
      sig: ["desk", "pick", "office"],
      tags: ["desk", "pick", "office", "light"]
    },
    {
      key: "grape-460",
      name: "100% Grape Juice - 460ml",
      family: "RESET",
      title: "Your Smooth Everyday Recharge",
      label: "GRAPE",
      sig: ["slow", "sip", "office"],
      tags: ["slow", "sip", "office", "desk"]
    },
    {
      key: "pear-pomelo-460",
      name: "100% Laiyang Pear & Double Pomelo Juice - 460ml",
      family: "RESET",
      title: "Your Crisp Citrus-Pear Reset",
      label: "PEAR + POMELO",
      sig: ["desk", "light", "food"],
      tags: ["desk", "light", "food", "meal"]
    },
    {
      key: "apple-1l",
      name: "100% Apple Juice - 1L",
      family: "FLOW",
      title: "Your Family Fridge Favourite",
      label: "APPLE 1L",
      sig: ["share", "sip", "fridge"],
      tags: ["share", "sip", "fridge"]
    },
    {
      key: "apple-460",
      name: "100% Apple Juice - 460ml",
      family: "RESET",
      title: "Your Crisp Desk-Side Refresh",
      label: "APPLE",
      sig: ["desk", "light", "office"],
      tags: ["desk", "light", "office"]
    },
    {
      key: "hawthorn-1250",
      name: "Hawthorn Juice - 1.25L",
      family: "REFRESH WITH FOOD",
      title: "Your Sharing-Table Companion",
      label: "HAWTHORN",
      sig: ["share", "meal", "food"],
      tags: ["share", "meal", "food", "fridge"]
    },
    {
      key: "hawthorn-310",
      name: "Hawthorn Juice - 310ml",
      family: "REFRESH WITH FOOD",
      title: "Your Meal-Time Refresh",
      label: "HAWTHORN",
      sig: ["move", "meal", "food"],
      tags: ["move", "meal", "food"]
    },
    {
      key: "pear-80-1l",
      name: ">80% Laiyang Pear Juice - 1L",
      family: "FLOW",
      title: "Your Easy Everyday Fridge Pour",
      label: "PEAR 80%+",
      sig: ["slow", "sip", "fridge"],
      tags: ["slow", "sip", "fridge", "share"]
    },
    {
      key: "pear-100-1l",
      name: "100% Laiyang Pear Juice - 1L",
      family: "FLOW",
      title: "Your Pure Pear Fridge Staple",
      label: "PEAR 100%",
      sig: ["share", "post", "fridge"],
      tags: ["share", "post", "fridge", "sip"]
    },
    {
      key: "pear-loquat-245",
      name: "Laiyang Pear with Loquat & Monk Fruit - 245ml",
      family: "MOVE",
      title: "Your Botanical Pocket Refresh",
      label: "PEAR + LOQUAT",
      sig: ["move", "light", "bag"],
      tags: ["move", "light", "bag", "slow"]
    },
    {
      key: "herbal-pear-245",
      name: "Laiyang Pear Juice w/ Herbal Ingredients - 245ml",
      family: "MOVE",
      title: "Your Herbal-Inspired Grab & Go",
      label: "HERBAL PEAR",
      sig: ["move", "pick", "bag"],
      tags: ["move", "pick", "bag"]
    },
    {
      key: "pear-60-1250",
      name: ">60% Laiyang Pear Juice - 1.25L",
      family: "FLOW",
      title: "Your Easy Sharing Pear Pour",
      label: "PEAR 1.25L",
      sig: ["share", "pick", "fridge"],
      tags: ["share", "pick", "fridge"]
    },
    {
      key: "pear-100-460",
      name: "100% Laiyang Pear Juice - 460ml",
      family: "RESET",
      title: "Your Everyday Pear Recharge",
      label: "PEAR 460",
      sig: ["slow", "light", "office"],
      tags: ["slow", "light", "office", "desk"]
    },
    {
      key: "pear-60-245",
      name: ">60% Laiyang Pear Juice - 245ml",
      family: "MOVE",
      title: "Your Pocket-Sized Everyday Refresh",
      label: "PEAR 245",
      sig: ["active", "light", "bag"],
      tags: ["active", "light", "bag", "move"]
    },
    {
      key: "pear-60-310",
      name: ">60% Laiyang Pear Juice - 310ml",
      family: "MOVE",
      title: "Your Easy Post-Movement Refresh",
      label: "PEAR 310",
      sig: ["active", "post", "workout"],
      tags: ["active", "post", "workout"]
    },
    {
      key: "pear-100-310",
      name: "100% Laiyang Pear Juice - 310ml",
      family: "MOVE",
      title: "Your Clean Active-Day Recharge",
      label: "PEAR 100%",
      sig: ["active", "light", "workout"],
      tags: ["active", "light", "workout", "post"]
    },
    {
      key: "nfc-pear-310",
      name: "NFC 100% Laiyang Pear Juice - 310ml",
      family: "MOVE",
      title: "Your Purest Post-Movement Match",
      label: "NFC PEAR",
      sig: ["active", "post", "bag"],
      tags: ["active", "post", "bag", "workout"]
    }
  ];

  const reasons = {
    MOVE:
      "Your answers point to a portable, personal-format drink that fits naturally into an active or on-the-go day.",

    RESET:
      "You’re looking for a personal everyday refresh, something easy to reach for between work, meals and the rest of your routine.",

    "REFRESH WITH FOOD":
      "You’re most likely to enjoy your drink alongside food, so we matched you with one of our bolder, meal-friendly profiles.",

    FLOW:
      "Your answers lean toward longer sipping occasions, home use or sharing, so a larger format makes the most sense."
  };

  let activeRoot = null;
  let step = 0;
  let answers = [null, null, null];

  function getEls(root) {
    return {
      modal: root.querySelector("[data-fruit-finder-modal]"),
      quiz: root.querySelector("[data-ff-quiz]"),
      result: root.querySelector("[data-ff-result]"),
      progress: root.querySelector("[data-ff-progress]"),
      stepLabel: root.querySelector("[data-ff-step-label]"),
      question: root.querySelector("[data-ff-question]"),
      hint: root.querySelector("[data-ff-hint]"),
      options: root.querySelector("[data-ff-options]"),
      back: root.querySelector("[data-ff-back]"),
      resultTitle: root.querySelector("[data-ff-result-title]"),
      resultProduct: root.querySelector("[data-ff-result-product]"),
      resultReason: root.querySelector("[data-ff-result-reason]"),
      resultLabel: root.querySelector("[data-ff-result-label]"),
      resultImage: root.querySelector("[data-ff-result-image]"),
resultLink: root.querySelector("[data-ff-result-link]"),
    };
  }

  function resetQuiz(root) {
    step = 0;
    answers = [null, null, null];

    const els = getEls(root);

    els.quiz.hidden = false;
    els.result.hidden = true;

    renderStep(root);
  }

  function renderStep(root) {
    const data = questions[step];
    const els = getEls(root);

    els.stepLabel.textContent =
      `Question ${step + 1} of ${questions.length}`;

    els.question.textContent = data.q;
    els.hint.textContent = data.hint;

    els.progress.style.width =
      `${((step + 1) / questions.length) * 100}%`;

    els.back.style.visibility =
      step === 0 ? "hidden" : "visible";

    els.options.innerHTML = "";

    data.options.forEach((option) => {
      const button = document.createElement("button");

      button.type = "button";

      button.className =
        "ff-option" +
        (answers[step] === option.id ? " is-selected" : "");

      button.innerHTML = `
        <strong>${option.title}</strong>
        <span>${option.sub}</span>
      `;

      button.addEventListener("click", () => {
  answers[step] = option.id;

  // Show selected state briefly before moving on
  renderStep(root);

  setTimeout(() => {
    if (step < questions.length - 1) {
      step += 1;
      renderStep(root);
    } else {
      showResult(root);
    }
  }, 180);
});

      els.options.appendChild(button);
    });
  }

  function chooseProduct() {
    const exact = products.find((product) =>
      product.sig.every(
        (value, index) => value === answers[index]
      )
    );

    if (exact) return exact;

    let best = null;
    let bestScore = -1;

    products.forEach((product, index) => {
      let score = 0;

      answers.forEach((answer) => {
        if (product.tags.includes(answer)) {
          score += 2;
        }
      });

      if (
        answers[0] === "share" &&
        product.family === "FLOW"
      ) {
        score += 1;
      }

      if (
        answers[1] === "meal" &&
        product.family === "REFRESH WITH FOOD"
      ) {
        score += 2;
      }

      if (
        (answers[0] === "active" ||
          answers[0] === "move") &&
        product.family === "MOVE"
      ) {
        score += 1;
      }

      if (
        (answers[0] === "desk" ||
          answers[0] === "slow") &&
        product.family === "RESET"
      ) {
        score += 1;
      }

      const tie =
        (
          answers.join("").charCodeAt(0) +
          index
        ) %
        7 /
        100;

      score += tie;

      if (score > bestScore) {
        bestScore = score;
        best = product;
      }
    });

    return best;
  }

  function getShopifyProducts(root) {
  const section =
    root.closest(".shopify-section") ||
    root.parentElement;

  const script =
    section?.querySelector(
      "[data-fruit-finder-products]"
    );

  if (!script) {
    console.warn(
      "Fruit Finder: Shopify product data not found."
    );
    return {};
  }

  try {
    return JSON.parse(script.textContent);
  } catch (error) {
    console.error(
      "Fruit Finder: Could not read Shopify products.",
      error
    );

    return {};
  }
}

  function showResult(root) {
  const product = chooseProduct();
  const els = getEls(root);

  const shopifyProducts =
    getShopifyProducts(root);

  const shopifyProduct =
    shopifyProducts[product.key];

  els.quiz.hidden = true;
  els.result.hidden = false;

  els.progress.style.width = "100%";

  els.resultTitle.textContent =
    product.title;

  els.resultReason.textContent =
    reasons[product.family] || "";

  /*
   * Use the real Shopify product title when
   * one has been selected in Theme Editor.
   */
  els.resultProduct.textContent =
    shopifyProduct?.title ||
    product.name;

  /*
   * Real Shopify featured image
   */
  if (shopifyProduct?.image) {
  els.resultImage.src = shopifyProduct.image;

  els.resultImage.alt =
    shopifyProduct.title || product.name;

  els.resultImage.hidden = false;
  els.resultLabel.hidden = true;
} else {
  els.resultImage.removeAttribute("src");
  els.resultImage.alt = "";
  els.resultImage.hidden = true;

  els.resultLabel.textContent = product.label;
  els.resultLabel.hidden = false;
}

  /*
   * Real Shopify product page
   */
  if (shopifyProduct?.url) {
    els.resultLink.href =
      shopifyProduct.url;

    els.resultLink.removeAttribute(
      "aria-disabled"
    );

    els.resultLink.classList.remove(
      "is-disabled"
    );
  } else {
    els.resultLink.href = "#";

    els.resultLink.setAttribute(
      "aria-disabled",
      "true"
    );

    els.resultLink.classList.add(
      "is-disabled"
    );
  }

  root.dataset.recommendedProduct =
    product.key;
}

  function openFinder(root) {
    if (!root) return;

    activeRoot = root;

    const modal =
      root.querySelector("[data-fruit-finder-modal]");

    resetQuiz(root);

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");

    document.body.style.overflow = "hidden";

    requestAnimationFrame(() => {
      root
        .querySelector("[data-close-fruit-finder]")
        ?.focus();
    });
  }

  function closeFinder(root) {
    if (!root) return;

    const modal =
      root.querySelector("[data-fruit-finder-modal]");

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");

    document.body.style.overflow = "";

    activeRoot = null;
  }

  function setupExternalFruitFinderTriggers() {
  document
    .querySelectorAll(FRUIT_FINDER_TRIGGER_SELECTORS)
    .forEach((trigger) => {
      trigger.removeAttribute("aria-disabled");
      trigger.setAttribute("role", "button");
      trigger.setAttribute("tabindex", "0");
      trigger.setAttribute(
        "data-open-fruit-finder",
        ""
      );
    });
}

setupExternalFruitFinderTriggers();

  document.addEventListener("click", (event) => {
    const openTrigger = event.target.closest(
    `[data-open-fruit-finder], ${FRUIT_FINDER_TRIGGER_SELECTORS}`
  );

  if (openTrigger) {
    event.preventDefault();

    const root = document.querySelector(
      "[data-fruit-finder-root]"
    );

    if (root) {
      openFinder(root);
    }

    return;
  }

    const closeTrigger =
      event.target.closest("[data-close-fruit-finder]");

    if (closeTrigger) {
      closeFinder(
        closeTrigger.closest("[data-fruit-finder-root]")
      );
      return;
    }

    const back =
      event.target.closest("[data-ff-back]");

    if (back) {
      const root =
        back.closest("[data-fruit-finder-root]");

      if (step > 0) {
        step -= 1;
        renderStep(root);
      }

      return;
    }

    const restart =
      event.target.closest("[data-ff-restart]");

    if (restart) {
      resetQuiz(
        restart.closest("[data-fruit-finder-root]")
      );
      return;
    }

    const resultLink =
  event.target.closest("[data-ff-result-link]");

if (
  resultLink &&
  resultLink.classList.contains("is-disabled")
) {
  event.preventDefault();
}

    if (
      activeRoot &&
      event.target.matches("[data-fruit-finder-modal]")
    ) {
      closeFinder(activeRoot);
    }
  });

  document.addEventListener("keydown", (event) => {
  if (
    event.key !== "Enter" &&
    event.key !== " "
  ) {
    return;
  }

  const trigger = event.target.closest(
    `[data-open-fruit-finder], ${FRUIT_FINDER_TRIGGER_SELECTORS}`
  );

  if (!trigger) return;

  event.preventDefault();

  const root = document.querySelector(
    "[data-fruit-finder-root]"
  );

  if (root) {
    openFinder(root);
  }
});
})();